<main class="inside">
    <section class="first_screen">
        <div class="page">
            <form class="search_block">
                <div class="tag_search_bar">
                    <div class="selected_tag_list">
                        <input type="text" placeholder="The Wave, Arizona">
                    </div>
                    <button>{{'offerWindow.go' | translate}} ></button>
                </div>
            </form>
        </div>
    </section>
    <section class="detail_page page">
        <h1 class="title_page">{{header}}</h1>
        <h4>{{subHeader}}</h4>
        <div class="location">{{subText1}}</div>
        <div class="location">{{subText2}}</div>
        <app-star-comonent [category]="category"></app-star-comonent>
        <div class="flex_block">
            <div class="left_part">
                <div class="carousel-holder">
                    <div class="col-md-12">
                        <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-slide-to="0" class="active"></li>
                                <li data-slide-to="i+1" *ngFor="let img of images; let i=index"></li>
                            </ol>

                            <div class="carousel-inner">
                                <div class="item active">
                                    <img class="slide-image" src="{{imgSrc1}}" alt="">
                                </div>
                                <div class="item" *ngFor="let img of images">
                                    <img class="slide-image" [src]="img" alt="">
                                </div>
                            </div>
                            <a class="left carousel-control" href="#carousel-example-generic" data-slide="prev">
                                <span class="glyphicon glyphicon-chevron-left"></span>
                            </a>
                            <a class="right carousel-control" href="#carousel-example-generic" data-slide="next">
                                <span class="glyphicon glyphicon-chevron-right"></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="list_table" [innerHTML]="longText  | safeHtml">
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>{{'detailsPage.date' | translate}}:</th>
                            <th>{{'detailsPage.single-room' | translate}}:</th>
                            <th>{{'detailsPage.double-room' | translate}}:</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let room of roomTypeNumber;let i=index">
                            <td>{{room.start | date: 'dd.MM.yyyy'}} - {{room.end | date: 'dd.MM.yyyy'}}</td>
                            <td class="price">{{room.price}}</td>
                            <td class="price">{{room.price1}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="right_part">
                <div class="list" [innerHTML]="shortText  | safeHtml">
                </div>
                <div class="zusatz">
                    <h2>{{'detailsPage.additional-services' | translate}}:</h2>
                    <div class="block">
                        <div class="t">{{'detailsPage.flight' | translate}}:</div>
                        <div class="item flex_block" *ngFor="let f of flightFrom">
                            <span>{{f.airportName}}</span>
                            <span><b>{{f.price}}</b></span>
                        </div>
                    </div>
                    <div class="block">
                        <div class="t">{{'detailsPage.board' | translate}}:</div>
                        <div class="item flex_block">
                            <span>{{firstBoardType}}</span>
                            <span><b>0,00 €</b></span>
                        </div>
                        <div class="item flex_block" *ngFor="let b of boards">
                            <span>{{b.boardTypeName}}</span>
                            <span><b>{{b.price}}</b></span>
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <button class="btn" id="inquiry" (click)="inquiry(id)">{{'detailsPage.inquiry-button' | translate}}</button>
                    <button class="btn o" (click)="booking(id);">{{'detailsPage.booking-button' | translate}}</button>
                    <button class="btn g" (click)="back()">{{'detailsPage.back-button' | translate}}</button>
                </div>
            </div>
        </div>
    </section>
</main>


// WEBPACK FOOTER //
// ./src/app/details/details.component.html